/* istanbul ignore file */
import { Logger } from '@services/logger/Logger';
import { ADPTags } from '@services/types';

export const ConsoleLogger: Logger = {
    info: (message: string, error?: Error, tags?: ADPTags) => {
        console.info('logLevel: info', 'message:', message, 'error:', error, 'tags:', tags);
    },
    warning: (message: string, error?: Error, tags?: ADPTags) => {
        console.warn('logLevel: warning', 'message:', message, 'error:', error, 'tags:', tags);
    },
    error: (message: string, error?: Error, tags?: ADPTags) => {
        console.error('logLevel: error', 'message:', message, 'error:', error, 'tags:', tags);
    },
    fatal: (message: string, error?: Error, tags?: ADPTags) => {
        console.error('logLevel: fatal', 'message:', message, 'error:', error, 'tags:', tags);
    },
};
